import { render, staticRenderFns } from "./managementPersonnel.vue?vue&type=template&id=d9df48ec&scoped=true"
import script from "./managementPersonnel.vue?vue&type=script&lang=js"
export * from "./managementPersonnel.vue?vue&type=script&lang=js"
import style0 from "./managementPersonnel.vue?vue&type=style&index=0&id=d9df48ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9df48ec",
  null
  
)

export default component.exports